import React, { ReactNode } from 'react';
import { classNames } from '../../utils/style';
import { fontTag } from '../../styles/typographyNew';

// Temporary interface for Dato Block.
// To be removed when the new TagBlock is ready
export interface TagBlockProps extends TagProps {
  title: string;
}

export interface TagProps {
  color?:
    | 'gray'
    | 'blue'
    | 'red'
    | 'green'
    | 'orange'
    | 'cyan'
    | 'purple'
    | 'plum'
    | 'peach'
    | 'sunglow';
  size?: 'default' | 'small';
  children?: ReactNode;
}

const tagSizeVariants = {
  default: 'py-[2px] px-[10px] rounded-[8px]',
  small: 'py-[0px] px-[6px] rounded-[6px]',
};

const tagColorVariants = {
  gray: 'bg-[#F9F9FB] text-[#60646C] border-[#E0E1E6]',
  blue: 'bg-[#F8F9FD] text-[#0157B2] border-[#D6DDFB]',
  red: 'bg-[#FFF7F7] text-[#CE2C31] border-[#FFCDCE]',
  green: 'bg-[#F5FBF5] text-[#2A7E3B] border-[#C9E8CA]',
  orange: 'bg-[#FFF7ED] text-[#CC4E00] border-[#FFD19A]',
  cyan: 'bg-[#F2FAFB] text-[#107D98] border-[#B5E9F0]',
  purple: 'bg-[#FAF7FE] text-[#6C44A4] border-[#E7D9F8]',
  plum: 'bg-[#FDF7FD] text-[#953EA3] border-[#F2D1F3]',
  peach: 'bg-[#FFF3F0] text-[#972A11] border-[#FFD5CC]',
  sunglow: 'bg-[#FFF7E6] text-[#8E6D1F] border-[#FFEBC2]',
};

/**
 * Tag component displays a small piece of information or status.
 *
 * @example
 * // Basic usage
 * <Tag>Basic Tag</Tag>
 *
 * @example
 * // With custom color and size
 * <Tag color="purple" size="small">New Feature</Tag>
 */
export const Tag = ({
  color = 'blue',
  size = 'default',
  children,
}: TagProps) => {
  return (
    <span
      className={classNames(
        'Tag',
        fontTag,
        tagSizeVariants[size],
        tagColorVariants[color],
        'h-fit border',
        'inline-flex items-center gap-[4px] whitespace-nowrap',
      )}
    >
      {children}
    </span>
  );
};
